<template>
  <div class="page-add">
    <div class="add-title">临时用户详情</div>
    <base-form formType="detail"></base-form>
  </div>
</template>

<script>
import BaseForm from "@/views/user/addTemporary/baseForm.vue";

export default {
  components: { BaseForm },
  created() {

  },
  methods:{
  },

};
</script>

<style lang="scss" scoped>

</style>
